import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeModeProvider } from "./context/ThemeModeContext";

const container = document.getElementById("root");

// index.php sends public pages with their head tags and a plain copy of the page for crawlers
// (all marked data-ssr). The app draws the page itself and Helmet sets the tags: drop the copies,
// so no tag is there twice and React starts on an empty root.
document.querySelectorAll("[data-ssr]").forEach((node) => node.remove());
if (container?.querySelector("[data-ssr-page]")) {
  container.textContent = "";
}

if (container) {
  const app = (
    <React.StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <ThemeModeProvider>
            <App />
          </ThemeModeProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  if (container.hasChildNodes()) {
    hydrateRoot(container, app);
  } else {
    const root = createRoot(container);
    root.render(app);
  }

  // Tell the start-up safety net in index.html that the app is running.
  window.__COACHHUB_BOOTED__ = true;
  window.__COACHHUB_HIDE_BOOT_MESSAGE__?.();
}



